export default __webpack_public_path__ + "static/media/InfoContainerBackground.68da352f.jpg";